export default {
  ASSET_GALLERY: {
    NO_ASSET: 'NO_ASSET',
    NOT_ENOUGH_TAGS: 'NOT_ENOUGH_TAGS',
    UPLOADING_INTERRUPTED: 'UPLOADING_INTERRUPTED',
    INVALID_USER: 'INVALID_USER',
    RUNNING_WORKER: 'RUNNING_WORKER',
    SELECTED_ASSET_FAIL: 'SELECTED_ASSET_FAIL',
    EDITTING: 'EDITTING'
  },
  ASSET_TAG_SELECTION: {
    UPDATE_TAG_FAIL: 'UPDATE_TAG_FAIL',
    NO_ASSET_SELECTED: 'NO_ASSET_SELECTED',
    TAG_UPDATE_FAILED: 'TAG_UPDATE_FAILED'
  },
  ASSET_LIST: {
    UNABLE_TO_LOAD: 'UNABLE_TO_LOAD'
  }
};



// WEBPACK FOOTER //
// ./src/components/common/AssetGalleryV2/constants/errors.js